var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.openSite}},[_c('img',{staticClass:"site-icon",attrs:{"src":_vm.siteIcon,"alt":"icon"}}),_c('span',{staticClass:"site-href",attrs:{"href":_vm.site}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }